export default __webpack_public_path__ + "static/media/network.06703621.jpg";